import handleErrors from '../../utils/handleErrors'
import { useDispatch, useSelector } from 'react-redux'
import { setEnquiryProduct, setShowEnquireModal } from '../../context/data/modalSlice'
import axios from 'axios'
import { useState } from 'react'

const EnquireModal = () => {
  const dispatch = useDispatch()
  const enquiredProductDetails = useSelector(state => state.modal.enquiryProduct)
  const [formData, setFormData] = useState({})
  const [page, setPage] = useState(1)
  const [enquirySentResponseMessage, setEnquirySentResponseMessage] = useState('')
  const [enquiryProcessing, setEnquiryProcessing] = useState(false)

  const handleFormElementChange = (e) => {
    try {
      e.preventDefault()
      const { name, value } = e.target
      if (name === 'quantity') {
        // Ensure quantity is a positive value
        if (/^(0|[1-9]\d*)?$/.test(value)) {
          setFormData(prevData => ({ ...prevData, [name]: value }))
        }
      } else {
        setFormData(prevData => ({ ...prevData, [name]: value }))
      }
    } catch (error) {
      throw new Error("Error in handling form element change: ", error)
    }
  }

  const handleEnquirySubmit = async (e) => {
    try {
      e.preventDefault()
      setEnquiryProcessing(true)
      const handleEnquiryFormResponse = await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_BACKEND_URL}/frontend/handleEnquiryForm`,
        data: { formData, productData: enquiredProductDetails },
      })
      setEnquirySentResponseMessage(handleEnquiryFormResponse.data.message)
      setPage(2)
      setEnquiryProcessing(false)
    } catch (error) {
      console.log("Error in handling enquiry submit: ", error)
      handleErrors({ error })
    }
  }

  return (
    <div className="modal">
      <div className="modalHeader" style={{ justifyContent: 'space-between' }}>
        <div style={{ fontSize: '1.4rem' }}>
          {enquiredProductDetails.productName}
        </div>
        <button id="crossDiv" className="white"
          onClick={(e) => {
            e.preventDefault();
            setPage(1)
            setEnquirySentResponseMessage('')
            setFormData({})
            dispatch(setShowEnquireModal(false))
            dispatch(setEnquiryProduct(null))
            document.body.style.overflow = 'auto'
          }}>
          &#10005;
        </button>
      </div>
      {page === 1 ?
        <>
          {enquiryProcessing ?
            <div className="modalContent"> Please Wait...</div>
            :
            <div className="modalContent">
              <div style={{ margin: '1rem 0rem', fontSize: '1.2rem' }}>
                Interested in this product or need more information? <br />
                Fill in the form below and our team will get back to you shortly.
              </div>
              <form onSubmit={handleEnquirySubmit} id="enquiryFormId" >
                <div className="flexDiv">
                  <div className="formGroup">
                    <label htmlFor="name">Name*</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      autoComplete='off'
                      required
                      value={formData.name}
                      onChange={handleFormElementChange}
                    />
                  </div>
                  <div className="formGroup">
                    <label htmlFor="email">Email*</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      autoComplete='off'
                      required
                      value={formData.email}
                      onChange={handleFormElementChange}
                    />
                  </div>
                </div>
                <div className="flexDiv">
                  <div className="formGroup">
                    <label htmlFor="mobile">Mobile*</label>
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      autoComplete='off'
                      required
                      value={formData.mobile}
                      onChange={handleFormElementChange}
                    />
                  </div>
                  <div className="formGroup">
                    <label htmlFor="quantity">Quantity</label>
                    <input
                      type="text"
                      id="quantity"
                      name="quantity"
                      autoComplete='off'
                      value={formData.quantity}
                      onChange={handleFormElementChange}
                    />
                  </div>
                </div>
                <div className="formGroup">
                  <label htmlFor="comments">Comments</label>
                  <textarea
                    rows={5}
                    id="comments"
                    name="comments"
                    autoComplete='off'
                    style={{ resize: 'none' }}
                    value={formData.comments}
                    onChange={handleFormElementChange}
                  />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '1rem 0rem' }}>
                  <button type="submit" style={{ width: '200px' }} >
                    Send Enquiry
                  </button>
                </div>
              </form >
            </div >
          }
        </>
        :
        <div className="modalContent">
          {enquirySentResponseMessage}
        </div>
      }
    </div >
  )
}

export default EnquireModal
